(() => {
  const R = document.querySelector('[data-nexby-header]');
  if (!R) return;
  const W = R.closest('.shopify-section') || R;
  const $ = (s, c = R) => c.querySelector(s);
  const $$ = (s, c = R) => [...c.querySelectorAll(s)];
  const doc = document.documentElement;
  const nav = $('#nexby-nav');
  const burger = $('[data-burger]');
  const sBtn = $('[data-search-open]');
  const sPanel = $('#nexby-search');
  const sIn = $('[data-search-input]');
  const desk = matchMedia('(min-width:990px)');
  const hover = matchMedia('(hover:hover)');
  const items = $$('[data-has-panel]');
  let layer = null;
  let from = null;

  const visible = (el) => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';

  const setLayer = (name, trigger) => {
    if (layer) {
      R.classList.remove('is-' + layer);
      (layer === 'nav' ? burger : sBtn)?.setAttribute('aria-expanded', 'false');
      doc.classList.remove('nexby-lock');
    }
    layer = name;
    if (!name) return;
    from = trigger;
    items.forEach((li) => setP(li, false));
    R.classList.add('is-' + name);
    (name === 'nav' ? burger : sBtn).setAttribute('aria-expanded', 'true');
    if (name === 'nav') doc.classList.add('nexby-lock');
    W.classList.remove('nexby-hidden');
    (name === 'nav' ? $('[data-close-nav]') : sIn).focus({ preventScroll: true });
  };
  const close = (restore = true) => {
    const f = from;
    setLayer(null);
    if (restore && f) f.focus({ preventScroll: true });
  };

  burger?.addEventListener('click', () => (layer === 'nav' ? close() : setLayer('nav', burger)));
  sBtn?.addEventListener('click', () => (layer === 'search' ? close() : setLayer('search', sBtn)));
  $('[data-close-nav]')?.addEventListener('click', () => close());
  $('[data-search-close]')?.addEventListener('click', () => close());
  $('[data-scrim]').addEventListener('click', () => close());
  desk.addEventListener('change', () => layer === 'nav' && close(false));

  const setP = (li, o) => {
    li.classList.toggle('is-open', o);
    $('.nexby-h__toggle', li).setAttribute('aria-expanded', o);
  };
  const closeP = (except) => items.forEach((li) => li !== except && setP(li, false));
  let timer;
  items.forEach((li) => {
    $('.nexby-h__toggle', li).addEventListener('click', () => {
      const o = !li.classList.contains('is-open');
      closeP(li);
      setP(li, o);
    });
    li.addEventListener('mouseenter', () => {
      if (!desk.matches || !hover.matches || layer) return;
      clearTimeout(timer);
      closeP(li);
      setP(li, true);
    });
    li.addEventListener('mouseleave', () => {
      if (!desk.matches || !hover.matches) return;
      timer = setTimeout(() => setP(li, false), 150);
    });
    li.addEventListener('focusin', (e) => {
      if (desk.matches && !layer && e.target.matches(':focus-visible')) {
        closeP(li);
        setP(li, true);
      }
    });
    li.addEventListener('focusout', (e) => {
      if (desk.matches && !li.contains(e.relatedTarget) && !li.matches(':hover')) setP(li, false);
    });
  });
  document.addEventListener('click', (e) => {
    if (desk.matches && !e.target.closest('[data-has-panel]')) closeP();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (layer) return close();
      const open = items.find((li) => li.classList.contains('is-open'));
      if (open) {
        setP(open, false);
        if (open.contains(document.activeElement)) $('.nexby-h__link', open).focus();
      }
    } else if (e.key === 'Tab' && layer) {
      const f = $$('a[href],button:not([disabled]),input', layer === 'nav' ? nav : sPanel).filter(visible);
      if (!f.length) return;
      const a = document.activeElement;
      if (e.shiftKey && (a === f[0] || !f.includes(a))) (e.preventDefault(), f[f.length - 1].focus());
      else if (!e.shiftKey && (a === f[f.length - 1] || !f.includes(a))) (e.preventDefault(), f[0].focus());
    }
  });

  let sticky = R.dataset.sticky === 'true';
  let last = scrollY;
  let hidden = false;
  let top = 0;
  let raf = 0;
  const measure = () => {
    let p = W.previousElementSibling;
    while (p && !p.classList.contains('shopify-section')) p = p.previousElementSibling;
    top = p ? p.getBoundingClientRect().bottom + scrollY : 0;
  };
  const tick = () => {
    raf = 0;
    const y = scrollY;
    R.classList.toggle('is-scrolled', y > 8);
    if (!sticky) return;
    const busy = layer || items.some((li) => li.classList.contains('is-open'));
    if (busy || y <= top + W.offsetHeight) hidden = false;
    else if (y > last + 4) hidden = true;
    else if (y < last - 4) hidden = false;
    if (Math.abs(y - last) > 4 || busy) last = y;
    W.classList.toggle('nexby-hidden', hidden);
  };
  addEventListener('scroll', () => raf || (raf = requestAnimationFrame(tick)), { passive: true });
  addEventListener('resize', () => (measure(), tick()));
  R.addEventListener('focusin', () => {
    hidden = false;
    W.classList.remove('nexby-hidden');
  });
  measure();
  tick();

  const cart = $('#cart-icon-bubble');
  const live = $('[data-cart-live]');
  if (cart) {
    const count = () => parseInt($('.cart-count-bubble .visually-hidden', cart)?.textContent, 10) || 0;
    let n = count();
    new MutationObserver(() => {
      const c = count();
      live.textContent = c ? $('.cart-count-bubble .visually-hidden', cart).textContent : '';
      if (c > n) {
        cart.classList.remove('is-pulse');
        void cart.offsetWidth;
        cart.classList.add('is-pulse');
      }
      n = c;
    }).observe(cart, { childList: true });
  }

  if (sIn) {
    const list = $('[data-results]');
    const pop = $('[data-popular]');
    const status = $('[data-search-status]');
    const d = R.dataset;
    const fmt = new Intl.NumberFormat(doc.lang || undefined, { style: 'currency', currency: d.currency || 'USD' });
    let ac;
    let dt;
    const el = (tag, cls, txt) => {
      const n = document.createElement(tag);
      if (cls) n.className = cls;
      if (txt) n.textContent = txt;
      return n;
    };
    const render = (products, q) => {
      const rows = products.map((p) => {
        const li = el('li');
        const a = el('a', 'nexby-s__item');
        a.href = p.url;
        const src = p.featured_image?.url || p.image;
        const img = el('img');
        if (src) {
          const u = new URL(src, location.href);
          u.searchParams.set('width', 112);
          img.src = u.href;
        }
        img.alt = '';
        img.width = img.height = 56;
        img.loading = 'lazy';
        a.append(img, el('span', 'nexby-s__t', p.title), el('span', 'nexby-s__p', fmt.format(+p.price)));
        li.append(a);
        return li;
      });
      const li = el('li');
      if (rows.length) {
        const all = el('a', 'nexby-s__all', d.allResults);
        all.href = `${d.searchUrl}?q=${encodeURIComponent(q)}`;
        li.append(all);
      } else {
        li.append(el('span', 'nexby-s__none', d.noResults));
      }
      list.replaceChildren(...rows, li);
      status.textContent = rows.length ? `${rows.length}` : d.noResults;
    };
    const run = async (q) => {
      ac = new AbortController();
      try {
        const r = await fetch(
          `${d.searchUrl}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`,
          { signal: ac.signal }
        );
        render((await r.json()).resources.results.products || [], q);
      } catch (e) {}
    };
    sIn.addEventListener('input', () => {
      clearTimeout(dt);
      ac?.abort();
      const q = sIn.value.trim();
      pop.hidden = !!q;
      if (!q) {
        list.replaceChildren();
        status.textContent = '';
        return;
      }
      dt = setTimeout(() => run(q), 200);
    });
  }
})();
